import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['requestedTruck', 'releasedOn', 'requestedDueDate', 'dueDateCondition', 'riskAlert'];

  connect() {
    this.changeRiskHandler();
  }

  changeRiskHandler() {
    const message = this.getRiskMessage();

    if (message) {
      this.riskAlertTarget.classList.remove('hidden');
      this.riskAlertTarget.querySelector('.title').innerHTML = message;
    } else {
      this.riskAlertTarget.classList.add('hidden');
    }
  }

  getRiskMessage() {
    const requestedTruck = this.requestedTruckTarget.value;
    const releasedOn = new Date(this.releasedOnTarget.value);
    const requestedDueDate = new Date(this.requestedDueDateTarget.value);
    let dueDateCondition = this.dueDateConditionTargets.find((target) => target.checked);
    if (dueDateCondition) { dueDateCondition = dueDateCondition.value; }

    if (!releasedOn.getTime() || !requestedDueDate.getTime()) {
      return null;
    }

    if (requestedDueDate - releasedOn === 0) {
      if (requestedTruck === '混載便') {
        return '混載便集荷は弊社引渡日が集荷日の翌日となる可能性が高いです。希望納期の再検討をお願いします。';
      }
      return '弊社引渡日当日の納期はご希望に沿えない場合がございます。改めてご希望を伺い、納期提案させていただく場合がございます。';
    }

    const oneDay = 24 * 60 * 60 * 1000;
    if (dueDateCondition === 'domestic_airport_departure') {
      if ((requestedDueDate - releasedOn) / oneDay <= 1 && requestedTruck === '混載便') {
        return '混載便集荷は弊社引渡日が納期日と同日となる可能性が高いです。改めてご希望を伺い、納期提案させていただく場合がございます。';
      }
    }

    if (dueDateCondition === 'local_airport_arrival') {
      if ((requestedDueDate - releasedOn) / oneDay <= 1) {
        return '弊社引渡日から短い納期が設定されています。改めてご希望を伺い、納期提案させていただく場合がございます。';
      }

      if ((requestedDueDate - releasedOn) / oneDay <= 2) {
        if (requestedTruck === '混載便') {
          return '混載便集荷のため弊社引渡日から短い納期が設定されています。改めてご希望を伺い、納期提案させていただく場合がございます。';
        }
        return 'フライトによっては短い納期が設定さている可能性があります。改めてご希望を伺い、納期提案させていただく場合がございます。';
      }

      if ((requestedDueDate - releasedOn) / oneDay <= 3) {
        return 'フライトによっては短い納期が設定さている可能性があります。改めてご希望を伺い、納期提案させていただく場合がございます。';
      }
    }

    if (dueDateCondition === 'local_delivery_to_arrival' && (requestedDueDate - releasedOn) / oneDay <= 3) {
      return 'フライトおよび現地配達先によっては短い納期が設定さている可能性があります。改めてご希望を伺い、納期提案させていただく場合がございます。';
    }

    if (['domestic_delivery_to_arrival', 'clearance_permitted'].includes(dueDateCondition) && requestedTruck === '混載便' && (requestedDueDate - releasedOn) / oneDay <= 1) {
      return '混載便集荷は弊社引渡日が納期日同日となる可能性がございます。改めてご希望を伺い、納期提案させていただく場合がございます。';
    }

    return null;
  }
}
